import { formatClock } from '../MentorAvailabilityPanel';
import type { MenteeBookingSlot } from './MenteePortalService';

type Props = {
    date: string | null;
    slots: MenteeBookingSlot[];
    selectedStartMinute: number | null;
    onSelect: (slot: MenteeBookingSlot) => void;
};

const MenteeSessionsSlotList = ({ date, slots, selectedStartMinute, onSelect }: Props) => {
    if (!date) {
        return (
            <div className="msess-slots">
                <p className="msess-sub">Select a day with availability to see open slots.</p>
            </div>
        );
    }

    const daySlots = slots
        .filter((s) => s.date === date)
        .slice()
        .sort((a, b) => a.startMinute - b.startMinute);

    if (daySlots.length === 0) {
        return (
            <div className="msess-slots">
                <p className="msess-sub">No slots on this day.</p>
            </div>
        );
    }

    return (
        <div className="msess-slots">
            <h3 className="msess-slots-title">Slots on {date}</h3>
            <div className="msess-slot-pills" role="list">
                {daySlots.map((slot) => {
                    const isPast = slot.state === 'past';
                    const isBooked = slot.state === 'booked';
                    const disabled = isPast;
                    const selected =
                        selectedStartMinute != null && selectedStartMinute === slot.startMinute;
                    const label = `${formatClock(slot.startMinute)} · ${slot.durationMinutes} min`;
                    const className = [
                        'msess-slot-pill',
                        selected ? 'is-selected' : '',
                        isBooked ? 'is-booked' : '',
                        isPast ? 'is-past' : '',
                    ]
                        .filter(Boolean)
                        .join(' ');
                    return (
                        <button
                            key={`${slot.date}-${slot.startMinute}`}
                            type="button"
                            role="listitem"
                            className={className}
                            disabled={disabled}
                            title={
                                isBooked
                                    ? 'Your booking — click to view details'
                                    : isPast
                                      ? 'Past — unbookable'
                                      : 'Select slot'
                            }
                            onClick={() => onSelect(slot)}
                        >
                            {label}
                            {isBooked ? ' · Booked' : ''}
                            {isPast ? ' · Past' : ''}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MenteeSessionsSlotList;
